import util from '@bmp-vue/core/api/util'
import Axios from 'axios'

const controller = 'Negociacoes'

function getAuthHeader() {
  try {
    const user = JSON.parse(localStorage.getItem('user'))
    return user && user.token ? { Authorization: `Bearer ${user.token}` } : {}
  } catch (e) {
    return {}
  }
}

function postComMensagem(path, dto, headers) {
  util.store.commit('addRequest')
  return Axios.post(process.env.VUE_APP_ROOT_API + path, dto, {
    ...headers,
    headers: { ...getAuthHeader(), ...(headers && headers.headers) }
  })
    .then(response => {
      util.store.commit('removeRequest')
      return response.data
    })
    .catch(err => {
      util.store.commit('removeRequest')
      const data = err.response && err.response.data
      const mensagem = data && (data.Mensagem || data.mensagem)
      return {
        success: false,
        codErro: err.response && err.response.status,
        mensagem:
          mensagem ||
          (err.response
            ? `${err.response.status} - ${err.response.statusText}`
            : 'Erro de comunicação com o servidor.')
      }
    })
}

export default Object.assign({}, util.GetCrud(controller, ['none']), {
  GetAllNegociacoesDuplicatas: function (dto) {
    return util.Axios.GetAll(controller + '/Duplicatas', dto)
  },
  GetTotalizadoresNegociacoesDuplicatas: function (dto) {
    return util.Axios.GetAll(controller + '/Duplicatas/Totalizadores', dto)
  },
  GetDetalheNegociacaoDuplicata: function (id) {
    return util.Axios.Get(`${controller}/Duplicata/Detalhe/${id}`)
  },
  GetHistoricoNegociacaoDuplicata: function (id) {
    return util.Axios.Get(`${controller}/Duplicata/${id}/Historico`)
  },
  AceitarProposta: function (id, token) {
    return postComMensagem(`${controller}/Duplicata/${id}/AceitarProposta`, {}, {
      headers: { token }
    })
  },
  RecusarProposta: function (id) {
    return postComMensagem(`${controller}/Duplicata/${id}/RecusarProposta`, {})
  },
  CancelarNegociacao: function (id, token) {
    return postComMensagem(`${controller}/Duplicata/${id}/CancelarProposta`, {}, {
      headers: { token }
    })
  },
  BaixarSegundaViaCnab: function (id) {
    return util.Axios.GetBlob(`${controller}/Duplicata/${id}/SegundaViaCnab`)
  },
  CalcularNegociacao: function (dto) {
    const body = {
      CodigosDuplicatas: dto.codigosDuplicatas ?? dto.CodigosDuplicatas,
      Taxa: dto.taxa !== undefined ? dto.taxa : dto.Taxa
    }
    return util.Axios.Post(`${controller}/Duplicata/Calcular`, body)
  },
  SolicitarNegociacao: function (dto, token) {
    return postComMensagem(`${controller}/Duplicata/Solicitar`, {
      CodigosDuplicatas: dto.codigosDuplicatas ?? dto.CodigosDuplicatas,
      Taxa: dto.taxa !== undefined ? dto.taxa : dto.Taxa
    }, {
      headers: { token }
    })
  },
  InformarLiquidacao: function (idNegociacao, codigoDuplicata, dto) {
    return postComMensagem(
      `${controller}/Duplicata/${idNegociacao}/${codigoDuplicata}/InformarLiquidacao`,
      dto
    )
  },
  ConfirmarPagamento: function (idNegociacao, dto) {
    return postComMensagem(
      `${controller}/Duplicata/${idNegociacao}/ConfirmarPagamento`,
      dto,
      {
        headers: {
          'Content-Type': `multipart/form-data; boundary=${dto._boundary}`
        }
      }
    )
  },
  DownloadTermoNegociacao: function () {
    return util.Axios.GetBlob(
      `${controller}/Download/Termo/NegociacaoDuplicata`
    )
  }
})
